<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_4"></a>Copyright © 1970, 1972 by Barry Hannah</p>
<p class="copyright">All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review.</p>
<p class="copyright"><em>Originally published by The Viking Press<br/>Published simultaneously in Canada<br/>Printed in the United States of America</em></p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Hannah, Barry.<br/>Geronimo Rex / Barry Hannah.<br/>p.       cm.<br/>eBook ISBN-13: 978-1-5558-4643-5<br/>1. Young men—Southern States—Fiction. I. Title.<br/>PS3558.A476G47      1998<br/>813′.54—dc21                   97-51147</p>
<p class="copyright1">Grove Press<br/>841 Broadway<br/>New York, NY 10003</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?ed811576